export function formatAddressOneLine(fields = {}) {
  const street = [fields.address, fields.address2].filter(Boolean).join(', ');
  const locality = [fields.city, fields.state, fields.zipCode].filter(Boolean).join(', ');
  return [street, locality].filter(Boolean).join(', ');
}

/** Dropdown label: street on line 1, city/state/ZIP on line 2. */
export function formatSuggestionDisplay(item = {}) {
  const line1 = item.mainText || item.description || '';
  const locality = [item.city, item.state, item.zipCode].filter(Boolean).join(', ');
  if (locality) {
    return { line1, line2: locality };
  }
  const secondary = String(item.secondaryText || '').replace(/, USA$/i, '').trim();
  return { line1, line2: secondary };
}
